export default __webpack_public_path__ + "static/media/headerh.16ba28c0.jpg";